module.exports = __webpack_public_path__ + "static/media/fahne.78de0164.mp3";